export enum OPERATION_KINDS_AUX {
  C = 'C',
  V = 'V',
}

export enum OPERATION_KINDS {
  BUY = 'buy',
  SELL = 'sell',
}

export enum BANK_ACCOUNT_KINDS {
  C = 'C',
  A = 'A',
}

export enum TOAST_KIND {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
}

export enum BUTTON_COLORS {
  PRIMARY = 'primary',
  BLUE = 'blue',
  RED = 'red',
}

export enum VOUCHER_STATUS {
  SENT = 0,
  CANCELED = 1,
  PENDING = 2,
  ERROR = 3,
  RETRY = 4,
}
